import { mutator } from 'satcheljs';
import { getSharedFolderUserEmails } from '../selectors/getSharedFolderUserEmails';
import { addSharedFolderUserEmail } from '../actions/addSharedFolderUserEmail';

/**
 * Mutator that adds the shared folder user email
 */
export default mutator(addSharedFolderUserEmail, actionMessage => {
    let sharedFolderUserEmails = getSharedFolderUserEmails();
    const index = sharedFolderUserEmails.indexOf(actionMessage.principalSMTPAddress);
    if (index == -1) {
        sharedFolderUserEmails.push(actionMessage.principalSMTPAddress);
    }
});
